var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCalendar = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.92578 2.75H11.8516V0.75H13.8271V2.75H18V20.75H0V2.75H3.9502V0.75H5.92578V2.75ZM2 8.75V18.75H16V8.75H2ZM5.92578 16.75H3.9502V14.75H5.92578V16.75ZM9.87695 16.75H7.90137V14.75H9.87695V16.75ZM13.8271 16.75H11.8516V14.75H13.8271V16.75ZM5.92578 12.75H3.9502V10.75H5.92578V12.75ZM9.87695 12.75H7.90137V10.75H9.87695V12.75ZM13.8271 12.75H11.8516V10.75H13.8271V12.75ZM2 8.25H16V4.75H2V8.25Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCalendar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/calendar.d11c1786f774462ba4698b63a40b7cec.svg";